import blogpic from "../../assets/blogpic.svg";
import "./BlogSection.css";

const BlogSection = ({ className = "" }) => {
  return (
    <section className={`blog ${className}`} id="blog">
      <div className="blog-container">
        <div className="lantern-container">
          <img className="blogpic" src={blogpic} alt="Blog Illustration" />
        </div>
        <div className="blog-content">
          <h2 className="blog-quote">
            "Every day is an opportunity to learn something new. Begin your
            journey with curiosity and a child-like sense of wonder."
          </h2>
          <a href="/blogs" className="btn">
            Checkout my space
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
